import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TlkModalWindowRef, TLK_MODAL_WINDOW_DATA, TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TranslateModule } from '@ngx-translate/core';

import { ImplantPositionComponent } from '@modules/tooth-editor/components/implant-position/implant-position.component';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { IntuitiveToothForDiagram } from '../../models/intuitive-tooth-for-diagram';
import { RxIntuitiveMiniTeethDiagramComponent } from '../rx-intuitive-mini-teeth-diagram/rx-intuitive-mini-teeth-diagram.component';
import { ToothModalResult, TOOTH_MODAL_ACTION } from '@modules/rx-intuitive-teeth-diagram/models/tooth-modal';

export interface RxIntuitiveImplantPositionModalData {
	teeth: IntuitiveToothForDiagram[];
	implantTypeId: number | null;
}

export interface RxIntuitiveImplantPositionModalPayload {
	toothPartialUpdate: {
		ImplantTypeID: number | null;
	} | null;
}

export type RxIntuitiveImplantPositionModalResult = ToothModalResult<RxIntuitiveImplantPositionModalPayload>;

@Component({
	selector: 'rx-intuitive-implant-position-modal',
	templateUrl: './rx-intuitive-implant-position-modal.component.html',
	styleUrls: ['./rx-intuitive-implant-position-modal.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		TranslateModule,
		TlkModalWindowModule,
		TlkButtonComponent,
		ImplantPositionComponent,
		CloseEmptyIconComponent,
		RxIntuitiveMiniTeethDiagramComponent
	]
})
export class RxIntuitiveImplantPositionModalComponent {
	readonly teeth: IntuitiveToothForDiagram[];
	currentImplantTypeId: number | null;

	constructor(
		private readonly dialogRef: TlkModalWindowRef<RxIntuitiveImplantPositionModalResult, RxIntuitiveImplantPositionModalComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public readonly data: RxIntuitiveImplantPositionModalData
	) {
		this.teeth = data.teeth;
		this.currentImplantTypeId = data.implantTypeId;
	}

	handleImplantTypeIdChange(newImplantTypeId: number | null): void {
		this.currentImplantTypeId = newImplantTypeId;
	}

	handleCancel(): void {
		this.dialogRef.close({
			action: TOOTH_MODAL_ACTION.Cancel,
			payload: { toothPartialUpdate: null }
		});
	}

	handleClose(): void {
		this.dialogRef.close({
			action: TOOTH_MODAL_ACTION.Save,
			payload: { toothPartialUpdate: { ImplantTypeID: this.currentImplantTypeId } }
		});
	}
}
